import fetch from 'services/request';
import { HomeLayoutCode, SHOP_DEVICE_TYPE } from './constants';
import { ICreateCustomerBody } from './types/customer';
import { IBodyApiAddDeviceWithStation } from './types/station';
import { IBodyShortLink } from './types/links';
import { ICleaningFeeResData, ICleaningFeeResDataV2 } from './types/cleaning-fee';
import { IDeleteProductByIdParams, IDeleteProductsParams } from './types/categories';

export const getCategories = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/category/get-all-by-category',
  });
};

export const getStaffs = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/staff/get-all-by-shop',
    params: {
      size: 1000,
    }
  });
};

export const getStaffsAvailable = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/staff/list-available-clock-in',
  });
};

export const getCustomers = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/customer/list-active',
  });
};

export const getCustomersFilter = (lastPhoneNumber: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/customer',
    params: { lastPhoneNumber },
  });
};

export const getShopInfo = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/shop/getInfoDetail',
  });
};


export const addNewCustomer = (body: ICreateCustomerBody) => {
  return fetch({
    method: 'post',
    url: 'api/v1/customer/create',
    body,
  });
};


const getListCoupon = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/coupon/list',
  });
};

const getCouponByCode = (code: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/coupon/get-by-code',
    params: { code }
  });
};

const getCouponPrint = (billId: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/coupon/list-print/' + billId,
  });
};

const getSpecialDiscountShop = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/special-discount/list',
  });
};

const getDiscountSetting = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/setting/discount-by-shop',
  });
};

const getOtherPaymentMethod = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/setting/other-payment-method',
  });
};

const getShopAllSetting = (shopId?: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/shop/all-setting',
    shopId,
  });
};

const getProductCategories = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/product/get-all-by-category',
  });
};

const addDevice = (shopId: string, deviceId: string, method: SHOP_DEVICE_TYPE) => {

  return fetch({
    method: 'post',
    url: 'api/v1/device',
    body: { deviceId, method, },
    shopId
  });
};

const getProductsVIP = () => {
  return fetch({
    method: 'post',
    url: 'api/v1/vip/get',
  });
};

const getCustomersRecent = () => {
  return fetch({
    url: 'api/v1/customer/list-recent',
    method: 'get',
    params: { size: 6 },
  });
};

const addCustomersRecent = (customerId: string) => {
  return fetch({
    url: 'api/v1/customer/add-recent',
    method: 'post',
    body: {
      customerId,
    }
  });
};

const addDeviceWithStation = (shopId: string, body: IBodyApiAddDeviceWithStation) => {
  return fetch({
    url: 'api/v1/device/manager',
    method: 'post',
    body,
    shopId,
  });
};

const getShopDevices = (shopId: string) => {
  return fetch({
    url: 'api/v1/device/manager',
    method: 'get',
    shopId
  });
};

const getShopTotalStation = (shopId: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/device/manager/total-station',
    shopId,
  });
};

const getShopScheduleBooking = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/shop/scheduler-booking',
  });
};

const getFeeCreditCard = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/payment/fee-credit-card',
  });
};

// /api/v1/staff/verify-pin-admin/{pinCode}
const verifyPinAdmin = (pinCode: string) => {
  return fetch({
    method: 'post',
    url: `api/v1/staff/verify-pin-admin/${pinCode}`,
  });
};

// /api/v1/staff/verify-pin-admin-v2/{pinCode}
const verifyPinAdminV2 = (pinCode: string, featureCode?: string) => {
  return fetch({
    method: 'post',
    url: `api/v1/staff/verify-pin-admin-v2/${pinCode}`,
    body: featureCode ? { featureCode } : undefined,
  });
};

const verifyNormalPin = (pinCode: string) => {
  return fetch({
    method: 'post',
    url: `api/v1/staff/verify-pin/${pinCode}`,
  });
};

const getTaxConfig = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/setting/tax-config'
  });
};
const getProductTaxConfig = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/product/setting-tax'
  });
};

const getShortLink = (body: IBodyShortLink) => {
  return fetch({
    method: 'post',
    url: 'api/v1/url/short-link',
    body,
  });
};

const getSimpleMenu = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/simple-menu/all'
  });
};

const getSimpleMenuConfigCheckIn = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/simple-menu/config-check-in',
  });
};


const getOptionTips = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/setting/option-tips',
  });
};

const getOptionTipsAll = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/setting/option-tips-all',
  });
};

const getQuickBookingService = () => {
  return fetch({
    method: 'get', url: '/api/v1/service/quick-booking',
  });
};

const getStaffAvailableBooking = () => {
  return fetch({
    method: 'get', url: '/api/v1/staff/available-booking-online',
  });
};

const checkConfigVerifyOtp = (type: string, shopId: string) => {
  return fetch({
    method: 'get',
    url: '/api/v1/shop/check-config-verify-otp',
    params: { type },
    shopId,
  });
};

const verifyOTP2Factor = (shopId: string, body: { otpToken: string, otpValue: string }) => {
  return fetch({
    method: 'post',
    url: '/api/v1/shop/verify-otp',
    body,
    shopId,
  });
};

const getPrintCheckSetting = () => fetch({
  method: 'get',
  url: '/api/v1/shop/setting-print-check',
});

const getSettingReferral = () => fetch({
  method: 'get',
  url: '/api/v1/setting/setting-referral',
});

const getAgreementConsentForm = () => fetch({
  method: 'get',
  url: '/api/v1/setting/agreement-consent-form',
});

const updateAgreementConsentForm = (body: {
  agreement: string,
  confirmInfo: string
}) => fetch({
  method: 'post',
  url: '/api/v1/setting/agreement-consent-form',
  body,
});

const getCleaningFee = () => fetch({
  method: 'get',
  url: '/api/v1/setting/cleaning-fee',
});
const updateCleaningFee = (body: ICleaningFeeResData) => fetch({
  method: 'post',
  url: '/api/v1/setting/cleaning-fee',
  body,
});
const getCleaningFeeV2 = () => fetch({
  method: 'get',
  url: '/api/v1/setting/cleaning-fee-v2',
});
const updateCleaningFeeV2 = (body: ICleaningFeeResDataV2) => fetch({
  method: 'post',
  url: '/api/v1/setting/cleaning-fee-v2',
  body,
});

const getNotificationById = (id: string) => fetch({
  method: 'get',
  url: `/api/v1/shop/read-system-notification/${id}`,
});

const getPermissionConfig = () => fetch({
  method: 'get',
  url: '/api/v1/permission/config',
});

const checkPermissionPin = (pinCode: string, moduleCode: string, featureCode: string) => fetch({
  method: 'post',
  url: '/api/v1/permission/check-pin',
  body: {
    pinCode,
    moduleCode,
    featureCode,
  }
});

const updateHomeLayout = (layoutCode: HomeLayoutCode) => fetch({
  method: 'post',
  url: '/api/v1/shop/home-layout',
  body: {
    layoutCode,
  },
});

const deleteProducts = (body: IDeleteProductsParams) => fetch({
  method: 'post',
  url: '/api/v1/product/delete',
  body: {
    ids: body.ids,
  },
});

const deleteProductById = (body: IDeleteProductByIdParams) => fetch({
  method: 'post',
  url: `/api/v1/product/delete/${body.id}`,
});

const shopApis = {
  getCategories,
  getStaffs,
  getCustomers,
  getStaffsAvailable,
  getShopInfo,
  addNewCustomer,
  getListCoupon,
  getCouponPrint,
  getSpecialDiscountShop,
  getDiscountSetting,
  getOtherPaymentMethod,
  getShopAllSetting,
  addDevice,
  getProductCategories,
  getProductsVIP,
  getCustomersRecent,
  addCustomersRecent,
  addDeviceWithStation,
  getShopDevices,
  getShopTotalStation,
  verifyPinAdmin,
  verifyPinAdminV2,
  getShopScheduleBooking,
  getCouponByCode,
  getFeeCreditCard,
  getTaxConfig,
  getProductTaxConfig,
  getShortLink,
  getSimpleMenu,
  getSimpleMenuConfigCheckIn,
  getOptionTips,
  getOptionTipsAll,
  getQuickBookingService,
  checkConfigVerifyOtp,
  verifyOTP2Factor,
  getStaffAvailableBooking,
  getPrintCheckSetting,
  getSettingReferral,
  verifyNormalPin,
  getAgreementConsentForm,
  updateAgreementConsentForm,
  getNotificationById,
  getCleaningFee,
  updateCleaningFee,
  getCleaningFeeV2,
  updateCleaningFeeV2,
  getPermissionConfig,
  checkPermissionPin,
  updateHomeLayout,
  deleteProducts,
  deleteProductById,
};

export default shopApis;
